import { render, staticRenderFns } from "./NotificationListItem.vue?vue&type=template&id=18b1364e&scoped=true&"
import script from "./NotificationListItem.vue?vue&type=script&lang=js&"
export * from "./NotificationListItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationListItem.vue?vue&type=style&index=0&id=18b1364e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1364e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VImg,VListItemAction,VListItemAvatar,VListItemSubtitle,VListItemTitle})
